import { useEffect } from "react";
import { Link } from "react-router-dom";

import { Lock, X } from "lucide-react";

const LimitReachedDialog = ({ message, onClose }) => {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <div className="audit-loader-overlay">
      <div className="audit-loader-card max-w-lg border-primary/30">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-6 ring-2 ring-primary/20">
          <Lock className="w-8 h-8 text-primary" />
        </div>

        <h2 className="text-2xl font-headline font-bold text-on-surface mb-2">
          Plan Limit Reached
        </h2>

        <p className="text-on-surface-variant text-lg mb-8 max-w-md">{message}</p>

        <div className="flex gap-4 w-full">
          <button
            onClick={onClose}
            className="flex-1 py-3 px-6 rounded-xl font-medium text-on-surface-variant hover:bg-surface-container-high transition-colors flex items-center justify-center gap-2"
          >
            <X className="w-4 h-4" /> Close
          </button>
          <Link
            to="/pricing"
            className="flex-1 py-3 px-6 rounded-xl font-bold text-on-primary bg-gradient-to-br from-primary to-primary-container hover:opacity-90 transition-colors shadow-lg shadow-primary/20 flex items-center justify-center gap-2"
          >
            View Plans
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LimitReachedDialog;
